/* eslint-disable @typescript-eslint/no-unused-vars */
import { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, List, ListItem, Snackbar, SnackbarCloseReason, TextField } from '@mui/material';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import { EmpFunService, IBaixaEmp } from '../../../shared/services/api/rh/EmpFun/EmpFunService';
import { IVFormErrors, useVForm, VForm, VTextField, VTextFieldData } from '../../../shared/forms';

export interface ConfirmationDialogRawProps {
  value: string;
  open: boolean;
  onClose: (value?: string) => void;
}

const formValidationSchema: yup.ObjectSchema<IBaixaEmp> = yup.object().shape({
  motivo: yup.string().required().min(7).max(50),
  datapgto: yup.date().required(),
});

export const BaixaEmpFun: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const { formRef, save, } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error' | 'info' | 'success'>('warning');

  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event,
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
    if (tms === 'success') {
      onClose();
      navigate('/empfun');
    }
  };

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleSave = (dados: IBaixaEmp) => {
    formValidationSchema.
      validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        EmpFunService
          .Baixa(props.value, dadosValidados)
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTms('success');
              setMsg('Baixa efetuada com sucesso!');
              setOpenmsg(true);
            }
          });
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
        errors.inner.forEach(error => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
        formRef.current?.setErrors(validationErrors);
      });
  };

  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 520 } }}
      maxWidth="xs"
      open={open}
      {...other}
    >
      <DialogTitle>Baixa de Emprestimo de Colaborador</DialogTitle>
      <DialogContent dividers>
        <VForm ref={formRef} onSubmit={handleSave}>
          <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg} autoHideDuration={900} onClose={handleCloseMsg}>
            <Alert
              onClose={handleCloseMsg}
              severity={tms}
              variant="filled"
              sx={{ width: '100%' }}
            >
              {msg}
            </Alert>
          </Snackbar>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <VTextFieldData
              fullWidth
              size='small'
              name='datapgto'
              label='Data Baixa'
              disabled={false}
            />
          </Grid>
          <Grid marginTop={2} item xs={12} sm={12} md={12} lg={12} xl={12}>
            <VTextField
              fullWidth
              size='small'
              name='motivo'
              label='Motivo da Baixa'
              disabled={false}
            />
          </Grid>
        </VForm>
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancelar
        </Button>
        <Button variant='outlined' autoFocus onClick={save}>Confirmar</Button>
      </DialogActions>
    </Dialog >

  );
}; 